import { Assistant } from '@/types';
import {assistantsService, convertApiAssistant} from "@/api/services/assistants.service.ts";

// Load single assistant by code from environment variable
export const loadAssistants = async (): Promise<Record<string, Assistant>> => {
    try {
        const assistantCode = import.meta.env.VITE_ASSISTANT_CODE;

        if (!assistantCode) {
            console.error('VITE_ASSISTANT_CODE environment variable is not set');
            return {};
        }

        const apiAssistant = await assistantsService.getAssistantByCode(assistantCode);

        if (!apiAssistant) {
            console.error('No assistant found with name/code:', assistantCode);
            return {};
        }

        const assistant = convertApiAssistant(apiAssistant);

        // Override display name if provided in environment
        // This preserves all other properties (icon, colors, etc.) from the original assistant
        const displayName = import.meta.env.VITE_ASSISTANT_DISPLAY_NAME;
        if (displayName) {
            assistant.name = displayName;
            // Icon, bgGradient, and all other styling from the original assistant are preserved
        }

        return { [apiAssistant.id]: assistant };
    } catch (error) {
        console.error('Failed to load assistant:', error);
        return {};
    }
};

// Export initial assistants (will be updated dynamically)
export let ASSISTANTS: Record<string, Assistant> = {};

